<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useUserSettingsStore } from '@/stores/userSettings'
import LangItem from './LangItem.vue'
import AvatarCard from '@/components/layout/AvatarCard.vue'
import NavigationItems from './NavigationItems.vue'
import Logo from './Logo.vue'

const authStore = useAuthStore()
const userSettingsStore = useUserSettingsStore()

const theme = ref(userSettingsStore.theme)
watch(
  () => userSettingsStore.theme,
  (newValue) => (theme.value = newValue),
)
</script>

<template>
  <aside
    class="from-sidebar text-muted-foreground flex h-screen w-16 min-w-16 flex-col items-center justify-between border-r bg-linear-to-b to-[#17467b] py-4 shadow-sm"
  >
    <div class="flex flex-col items-center gap-6">
      <Logo />
      <div class="flex flex-col items-center gap-6">
        <NavigationItems />
      </div>
    </div>

    <div class="flex flex-col items-center gap-6 pb-5">
      <LangItem />
      <AvatarCard v-if="authStore.isLoggedIn" />
    </div>
  </aside>
</template>
